<template>
  <!-- <b-card :header="caption"> -->
  <div>
    <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="sendTos" :fields="fields" :current-page="currentPage" :per-page="perPage">
      <template slot="status" slot-scope="data">
        <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
      </template>
      <template slot="編集" slot-scope="data">
        <b-button @click="edit(data.item['編集'])" variant="link" class="pointer" size="lg">
          <i class="fa fa-edit"></i></b-button>
      </template>
    </b-table>
    <nav>
      <b-pagination :total-rows="getRowCount(sendTos)" :per-page="perPage" v-model="currentPage" prev-text="前ページ" next-text="次ページ" hide-goto-end-buttons/>
    </nav>
  </div>
  <!-- </b-card> -->
</template>

<script>
// import IntegrationStore from "../../store/integration";

const bindSendTos = (self) => {
  const sendTos = []
  const integration = self.integration
  if (integration) {
    console.log(integration.IntegrationId)
  }
  if (integration && integration.SendTos && integration.SendTos.length > 0) {
    for (const sendTo of integration.SendTos) {
      sendTos.push({
        "編集": sendTo.SendToId,
        "送信先ID": sendTo.SendToId,
        "変換モジュールID": sendTo.ModuleId,
        "変換パラメータ": sendTo.ModuleParams,
        "送信手段": sendTo.SendMethod,
        "送信パラメータ": sendTo.SendParams
      })
    }
  }
  // console.dir(sendTos)
  return sendTos
}

export default {
  name: 'c-table-send-to',
  props: {
    integration: {
      type: Object,
      default: null
    },
    caption: {
      type: String,
      default: 'TableSendTo'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sendTos: bindSendTos(this),
      fields: [
        {key: '編集'},
        {key: '送信先ID'},
        {key: '変換モジュールID'},
        {key: '変換パラメータ'},
        {key: '送信手段'},
        {key: '送信パラメータ'}
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0
    }
  },
  created() {
    // debugger
    // console.log(this.integration)
  },
  methods: {
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    },
    getRowCount (sendTos) {
      return sendTos.length
    },
    update() {
      this.sendTos = bindSendTos(this)
    },
    edit(sendToId) {
      // console.dir(sendToId)
      this.$emit('edit', sendToId)
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/TableSendTo.vue